import React from 'react';

const SvgPaymentDelete = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path d="M16.383 5.035a.54.54 0 110 1.08h-.46l-.895 10.368a1.567 1.567 0 01-1.568 1.483H6.47a1.567 1.567 0 01-1.568-1.486L4.11 6.116h-.563a.54.54 0 110-1.081zM14.83 6.194H5.203l.78 10.227c.013.26.227.464.488.464h6.989c.26 0 .475-.204.487-.464l.001-.022.882-10.205zM7.833 7.89a.542.542 0 01.585.495l.453 5.463a.54.54 0 01-1.08.09l-.453-5.464a.542.542 0 01.495-.584zm4.385 0a.54.54 0 01.495.584l-.454 5.463a.541.541 0 01-1.08-.09l.455-5.462a.542.542 0 01.584-.495zM12.87 3a.54.54 0 110 1.08H7.061a.54.54 0 110-1.08z" />
  </svg>
);

export default SvgPaymentDelete;
